import {
  NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT,
  NOTIFICATION_SETTINGS_VARIANT
} from './notifications.constants'
import { NotificationSettingsOptions } from './notifications.types'

export const NOTIFICATIONS_SETTINGS: NotificationSettingsOptions = {
  office: [
    {
      title: 'Задачи',
      key: 'options-office-tasks',
      fields: [
        {
          name: 'Новая задача',
          key: 'new-task',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Новая важная задача',
          key: 'new-primary-task',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Просроченная задача',
          key: 'overdue-task',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Новые файлы в задаче',
          key: 'new-file-in-task',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Новые комментарии к задаче',
          key: 'new-comment-in-task',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Изменение статуса задачи',
          key: 'change-status-task',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Изменение сроков задачи',
          key: 'change-timing-task',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        }
      ]
    },
    {
      title: 'Проекты',
      key: 'options-office-projects',
      fields: [
        {
          name: 'Приглашение на проект',
          key: 'invite-project',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Изменение сроков проекта',
          key: 'change-terms',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Изменение сроков раздела',
          key: 'change-part-terms',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Изменение технического задания',
          key: 'change-update-technical-task',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Изменение статуса проекта',
          key: 'change-status',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Выход участника из проекта',
          key: 'member-exit-project',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          name: 'Изменение роли',
          key: 'change-role',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        }
      ]
    },
    {
      title: 'Другое',
      key: 'options-office-others',
      fields: [
        {
          name: 'Завершение срока действия пакета',
          key: 'end-action-packet',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        }
      ]
    }
  ],
  job: [
    {
      key: 'options-specialists',
      title: 'Специалистам',
      fields: [
        {
          key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.RECOMMENDED_TENDERS,
          name: 'Рекомендуемые заказы',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.FEEDBACKS_AND_MESSAGES,
          name: 'Отклики и сообщения',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.VERIFY_STATUS,
          name: 'Статус верификации',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.LIKES_PROJECTS,
          name: 'Лайки к работам в портфолио',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        }
      ]
    },
    {
      key: 'options-companies',
      title: 'Компаниям',
      fields: [
        {
          key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.RECOMMENDED_TENDERS,
          name: 'Рекомендуемые заказы',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.FEEDBACKS_AND_MESSAGES,
          name: 'Отклики и сообщения',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.LIKES_PROJECTS,
          name: 'Лайки к работам в портфолио',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        }
      ]
    },
    {
      key: 'options-others',
      title: 'Другое',
      fields: [
        {
          key: NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT.PACKET_EXPIRATION_DATE,
          name: 'Завершение срока действия пакета',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        }
      ]
    }
  ],
  shop: [
    {
      key: 'options-shop-projects',
      title: 'Проекты',
      fields: [
        {
          key: 'messages',
          name: 'Сообщения',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          key: 'add-project-to-favorite',
          name: 'Добавление проекта в избранное',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        }
      ]
    },
    {
      key: 'options-shop-models',
      title: 'BIM-Модели',
      fields: [
        {
          key: 'messages',
          name: 'Сообщения',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        },
        {
          key: 'add-project-to-favorite',
          name: 'BIM-Добавление модели в избранное',
          defaultValue: NOTIFICATION_SETTINGS_VARIANT.ALL
        }
      ]
    }
  ]
}
